(function() {
	if (window.vimeoSetupComplete) return;

	console.log('Vimeo setup running')

	const vimeoID = 'vimeo-player-';

	const containers = document.querySelectorAll(`[id*="${vimeoID}"]`);

	if (containers.length) {
		
		
		for (let container of containers) {
			let player = new Vimeo.Player(`${vimeoID}${container.dataset.id}`, {
				id: container.dataset['vimeo-id'],
				autoplay: false,
				byline: false,
				controls: false,
				loop: false,
				muted: false,
				title: false,
				width: '100%'
			});

			const playButton = document.querySelector(`.vimeo-control-button[data-id="${container.dataset.id}"] .play`);
			const pauseButton = document.querySelector(`.vimeo-control-button[data-id="${container.dataset.id}"] .pause`);
			const wrapper = document.querySelector(`.video-wrapper[data-id="${container.dataset.id}"]`);

			playButton.addEventListener('click', function() {
				player.play().catch(err => console.error(err));
			});

			pauseButton.addEventListener('click', function() {
				player.pause().catch(err => console.error(err));
			});

			wrapper.addEventListener('click', function() {
				pauseButton.classList.remove('hide');
			});

			wrapper.addEventListener('mouseenter', function() {
				pauseButton.classList.remove('hide');
			});

			wrapper.addEventListener('mouseleave', function() {
				if (this.classList.contains('playing')) {
					pauseButton.classList.add('hide');
				}
			})

			player.on('play', function() {
				wrapper.classList.add('playing');

				console.log('playing');

				setTimeout(function() {
					pauseButton.classList.add('hide');
				}, 1000);
			});

			player.on('pause', function() {
				wrapper.classList.remove('playing');
			});

			player.on('ended', function() {
				wrapper.classList.remove('playing');
			});
		}

		window.vimeoSetupComplete = true;
	}
})()


